document.addEventListener("DOMContentLoaded", function () {
    // показать/скрыть пароль
    document.querySelectorAll('input[type="password"]').forEach((input) => {
        const wrapper = document.createElement("div");
        wrapper.className = "password-toggle";
        input.parentNode.insertBefore(wrapper, input);
        wrapper.appendChild(input);

        wrapper.addEventListener("click", function () {
            if (input.type === "password") {
                input.type = "text";
                wrapper.classList.add("show");
            } else {
                input.type = "password";
                wrapper.classList.remove("show");
            }
        });
    });

    // Функция для поиска первой ошибки
    function findFirstError() {
        // Ищем общие ошибки формы
        const formErrors = document.getElementById("form-errors-top");
        if (formErrors && formErrors.querySelector(".alert-danger")) {
            return formErrors;
        }

        // Ищем ошибки полей
        const fieldErrors = document.querySelector(".invalid-feedback.d-block");
        if (fieldErrors) {
            return fieldErrors.closest(".mb-3") || fieldErrors;
        }

        // Ищем ошибки в формсете
        const formsetErrors = document.querySelector(".item-form .invalid-feedback.d-block");
        if (formsetErrors) {
            return formsetErrors.closest(".item-form") || formsetErrors;
        }

        return null;
    }

    // Прокрутка к ошибке
    const firstError = findFirstError();
    if (firstError) {
        // Плавная прокрутка
        firstError.scrollIntoView({
            behavior: "smooth",
            block: "center",
        });

        // Временная подсветка
        firstError.classList.add("highlight-error");
        setTimeout(() => {
            firstError.classList.remove("highlight-error");
        }, 3000);
    }
});

document.addEventListener("DOMContentLoaded", function () {
    // Инициализация всех multiselect-полей
    document.querySelectorAll(".m2m-wrap").forEach((container) => {
        const hiddenSelect = container.querySelector("select[multiple]");
        const searchInput = container.querySelector(".m2m-search-input");
        const selectedThemes = container.querySelector(".m2m-selected");
        const optionsContainer = container.querySelector(".m2m-options");
        const dropdownToggle = container.querySelector(".m2m-dropdown-toggle");

        // Получаем максимальное количество из data-атрибута или устанавливаем по умолчанию null (без ограничений)
        const maxSelection = container.dataset.maxSelection ? parseInt(container.dataset.maxSelection) : null;

        if (!hiddenSelect) return;

        // Инициализация
        init();

        function init() {
            updateSelectedThemes();
            setupEventListeners();
        }

        function updateSelectedThemes() {
            selectedThemes.innerHTML = "";
            Array.from(hiddenSelect.selectedOptions).forEach((option) => {
                const tag = document.createElement("div");
                tag.className = "m2m-tag";
                tag.innerHTML = `
                ${option.text}
                <span class="m2m-tag-remove" data-value="${option.value}">×</span>
            `;
                selectedThemes.appendChild(tag);
            });

            searchInput.placeholder = hiddenSelect.selectedOptions.length === 0 ? "Выберите..." : "";
            // Блокируем поле ввода, если достигнут лимит
            if (maxSelection !== null && hiddenSelect.selectedOptions.length >= maxSelection) {
                searchInput.disabled = true;
                searchInput.placeholder = "Достигнут лимит выбора";
            } else {
                searchInput.disabled = false;
            }
        }

        function updateOptions() {
            optionsContainer.innerHTML = "";
            const searchTerm = searchInput.value.toLowerCase();
            let hasMatches = false;

            Array.from(hiddenSelect.options).forEach((option) => {
                if (!option.selected && (option.text.toLowerCase().includes(searchTerm) || searchTerm === "")) {
                    const optionElement = document.createElement("div");
                    optionElement.className = "m2m-option";
                    optionElement.textContent = option.text;
                    optionElement.dataset.value = option.value;

                    // Проверяем, можно ли добавить еще элементы
                    const canSelectMore = maxSelection === null || hiddenSelect.selectedOptions.length < maxSelection;

                    optionElement.addEventListener("mousedown", (e) => {
                        e.preventDefault();

                        if (!canSelectMore) return;

                        option.selected = true;
                        updateSelectedThemes();
                        updateOptions();
                        searchInput.value = "";
                        searchInput.focus();
                    });

                    if (!canSelectMore) {
                        optionElement.style.opacity = "0.5";
                        optionElement.style.cursor = "not-allowed";
                    }

                    optionsContainer.appendChild(optionElement);
                    hasMatches = true;
                }
            });

            if (!hasMatches) {
                const noResults = document.createElement("div");
                noResults.className = "m2m-no-results";
                noResults.textContent = "Ничего не найдено";
                optionsContainer.appendChild(noResults);
            }
        }

        function toggleDropdown(show = true) {
            optionsContainer.style.display = show ? "block" : "none";
            if (show) {
                updateOptions();
                searchInput.focus();
            }
        }

        function setupEventListeners() {
            // Поиск и фокус
            searchInput.addEventListener("input", () => {
                updateOptions();
                toggleDropdown(true);
            });

            searchInput.addEventListener("focus", () => toggleDropdown(true));

            // Клик по стрелке
            dropdownToggle?.addEventListener("click", (e) => {
                e.stopPropagation();
                toggleDropdown(optionsContainer.style.display !== "block");
            });

            // Удаление тегов
            selectedThemes.addEventListener("click", (e) => {
                if (e.target.classList.contains("m2m-tag-remove")) {
                    e.stopPropagation();
                    const option = Array.from(hiddenSelect.options).find((opt) => opt.value === e.target.dataset.value);

                    if (option) {
                        option.selected = false;
                        updateSelectedThemes();
                        updateOptions();
                        searchInput.focus();
                    }
                }
            });

            // Закрытие при клике вне элемента
            document.addEventListener("click", (e) => {
                if (!container.contains(e.target)) {
                    toggleDropdown(false);
                }
            });

            // Закрытие по ESC
            searchInput.addEventListener("keydown", (e) => {
                if (e.key === "Escape") toggleDropdown(false);
            });
        }
    });

    // динамический селект с нажатием на кнопку
    document.querySelectorAll(".dynamic-select").forEach(function (select) {
        select.addEventListener("change", function () {
            // Находим ближайшую форму (родителя)
            const form = this.closest("form");
            if (form) {
                form.submit();
            }
        });
    });
});
